var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCircle)?_c('div',{staticClass:"loader-spinner",class:{
    'loader-spinner--white': _vm.isWhite,
    'loader-spinner--absolute': _vm.isAbsolute,
  }},[_c('svg',{staticClass:"loader-spinner__item",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"loader-spinner__path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none","stroke":"currentColor","stroke-width":"5","stroke-miterlimit":"10"}})])]):_c('div',{staticClass:"loader",class:{
    'loader--white': _vm.isWhite,
    'loader--absolute': _vm.isAbsolute,
  }},[_c('div',{staticClass:"loader__circle"})])}
var staticRenderFns = []

export { render, staticRenderFns }